<wj-flex-chart #atsScatterChart [chartType]="Wijmo.ChartType.Scatter" [bindingX]="'scoreAts'"
               appIntersectionObserver (intersectionCallback)="onChartInitialized(atsScatterChart)">

    <wj-flex-chart-axis #axisX wjProperty="axisX" title="Account Tiering Score" [axisLine]="true" format="p0"
                        [majorGrid]="true" [minorGrid]="true"
                        (rangeChanged)="onScatterChartRangeChanged(atsScatterChart, axisX, axisY, $event)">
    </wj-flex-chart-axis>

    <wj-flex-chart-axis #axisY wjProperty="axisY"  title="Target Rate Change" [axisLine]="true" format="p0"
                        [majorGrid]="true" [minorGrid]="true"
                        (rangeChanged)="onScatterChartRangeChanged(atsScatterChart, axisX, axisY, $event)">">
    </wj-flex-chart-axis>

    <wj-flex-chart-series #keyAccounts [bindingX]="'scoreAts'" [binding]="bindingY()" [tooltipContent]="ttc" [symbolStyle]="Series1Style">
    </wj-flex-chart-series>

    <wj-flex-chart-series #nonKeyAccounts [bindingX]="'scoreAts'" [binding]="bindingY()" [tooltipContent]="ttc" [symbolStyle]="Series2Style">
    </wj-flex-chart-series>

    <wj-flex-chart-annotation-layer #atsScatterChartTieringRangeAnnotations class="ats-annotation-layer">
    </wj-flex-chart-annotation-layer>

    <wj-flex-chart-gestures #chartGestures [interactiveAxes]="Wijmo.InteractiveAxes.X" [mouseAction]="Wijmo.MouseAction.Zoom">
    </wj-flex-chart-gestures>

    <wj-flex-chart-annotation-layer>
        @if (!hasData()) {
            <!-- Center text, intended to server as an overlay for example to inform the user that no data is available -->
            <wj-flex-chart-annotation-text [attachment]="Wijmo.AnnotationAttachment.Relative" [text]="noDataAlertText()"
                                           [position]="Wijmo.AnnotationPosition.Center" [point]="{x:0.5, y:0.5}"
                                           [style]="{ 'fill': '#ccc', 'font-size': '36px' }">

            </wj-flex-chart-annotation-text>
        }

    </wj-flex-chart-annotation-layer>
</wj-flex-chart>
